import pkg from '../package.json' assert { type: 'json' }
export default pkg.version
